// source: pbtypes/gen/user_camera/recording_mode.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.user_camera.RecordingMode', null, global);
goog.exportSymbol('proto.user_camera.RecordingMode.Enum', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.user_camera.RecordingMode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.user_camera.RecordingMode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.user_camera.RecordingMode.displayName = 'proto.user_camera.RecordingMode';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.user_camera.RecordingMode.prototype.toObject = function(opt_includeInstance) {
  return proto.user_camera.RecordingMode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.user_camera.RecordingMode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.user_camera.RecordingMode.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.user_camera.RecordingMode}
 */
proto.user_camera.RecordingMode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.user_camera.RecordingMode;
  return proto.user_camera.RecordingMode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.user_camera.RecordingMode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.user_camera.RecordingMode}
 */
proto.user_camera.RecordingMode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.user_camera.RecordingMode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.user_camera.RecordingMode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.user_camera.RecordingMode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.user_camera.RecordingMode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.user_camera.RecordingMode.Enum = {
  VIDEO_DEFAULT: 0,
  VIDEO_1080P_30FPS: 1,
  VIDEO_1080P_30FPS_HDR: 12,
  VIDEO_1080P_FULL_30FPS: 25,
  VIDEO_1080P_FULL_30FPS_HDR: 26,
  VIDEO_1080P_60FPS: 3,
  VIDEO_1080P_60FPS_HDR: 13,
  VIDEO_1080P_120FPS: 9,
  VIDEO_2_7K_30FPS: 14,
  VIDEO_2_7K_30FPS_HDR: 15,
  VIDEO_2_7K_60FPS: 16,
  VIDEO_2_7K_60FPS_HDR: 17,
  VIDEO_4K_24FPS: 6,
  VIDEO_4K_24FPS_HDR: 11,
  VIDEO_4K_30FPS: 2,
  VIDEO_4K_30FPS_HDR: 10,
  VIDEO_4K_48FPS: 5,
  VIDEO_4K_48FPS_HDR: 7,
  VIDEO_4K_60FPS: 4,
  VIDEO_4K_60FPS_HDR: 8,
  VIDEO_4K_FULL_30FPS: 18,
  VIDEO_4K_FULL_30FPS_HDR: 19,
  VIDEO_8K_30FPS: 20,
  VIDEO_8K_24FPS: 21,
  VIDEO_4K_120FPS: 22,
  VIDEO_4K_FULL_60FPS: 23,
  VIDEO_4K_FULL_24FPS: 24,
  VIDEO_4K_DEEP_30FPS: 27,
  VIDEO_4K_DEEP_FULL_30FPS: 28,
  VIDEO_1080P_DEEP_30FPS: 29,
  VIDEO_1080P_DEEP_FULL_30FPS: 30,
  VIDEO_1080P_24FPS: 31,
  VIDEO_1080P_FULL_24FPS: 32,
  PHOTO_DEFAULT: 100,
  PHOTO_HDR: 101,
  PHOTO_NIGHT: 102,
  PHOTO_HIGH_RES: 103,
  PHOTO_24MP: 105,
  PHOTO_32MP: 106,
  PHOTO_WITH_VIDEO_DEFAULT: 107,
  PHOTO_QBC_RAW: 104,
  VIDEO_2K_30FPS: 34,
  VIDEO_2K_30FPS_HDR: 33,
  VIDEO_2K_60FPS: 35,
  VIDEO_5K_16FPS: 36,
  PHOTO_NAV_G47: 109,
  PHOTO_NAV_R71: 111,
  PHOTO_NAV_HDR: 108,
  PHOTO_NAV_HIGH_RES: 110,
  VIDEO_1080P_30FPS_MFG_CAL: 37
};

goog.object.extend(exports, proto.user_camera);
